import React from 'react';

import { CurrentRoute } from './types';

export default React.createContext<CurrentRoute | null>(null);
